<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Alimentación"
          container-class="tag-badge mt-5 mb-4"
        />
      </div>
      <div v-if="canDelete && !disabled" class="col-1 d-flex justify-content-end align-items-center">
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="$emit('delete')"
        />
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante requiere ser asistido al comer (ser alimentado).
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <custom-radio
                id="rgNutritionStudentRequireAssistanceToEat"
                v-model="value.nutritionStudentRequireAssistanceToEat"
                :change-event="onChangeStudentRequireAssistanceToEat"
                name="studentRequireAssistance"
                label=""
                is-question-list
                :options="studentRequireAssistanceToEatOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante requiere asistencia con su gastrostomía.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <custom-radio
                v-model="value.nutritionStudentRequireAssistanceWithYourGastronomy"
                :change-event="onChangeStudentRequireAssistanceWithYourGastronomy"
                name="studentRequireAssistanceWithYourGastronomy"
                label=""
                :options="studentRequireAssistanceWithYourGastronomyOptions"
                is-question-list
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
          <CustomTextArea
            id="studentNeedsNutritionComments"
            v-model="value.nutritionComments"
            class="mt-2"
            :placeholder="'Escribe un comentario'"
            :maxlength="3000"
            show-char-count
            :count-classes="['d-block text-right']"
            :rows="5"
            :disabled="disabled"
          />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

export default {
  name: "Nutrition",
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    let itemIndex = null;
    if (this.value.nutritionStudentRequireAssistanceToEat != null) {
      if (this.value.nutritionStudentRequireAssistanceToEat) {
        itemIndex = this.studentRequireAssistanceToEatOptions.findIndex(
          x => x.value
        );
      } else {
        itemIndex = this.studentRequireAssistanceToEatOptions.findIndex(
          x => !x.value
        );
      }
      const itemRequireAssistanceToEat = this
        .studentRequireAssistanceToEatOptions[itemIndex];
      itemRequireAssistanceToEat.check = true;
      this.studentRequireAssistanceToEatOptions[
        itemIndex
      ] = itemRequireAssistanceToEat;
    }

    if (
      this.value.nutritionStudentRequireAssistanceWithYourGastronomy != null
    ) {
      if (this.value.nutritionStudentRequireAssistanceWithYourGastronomy) {
        itemIndex = this.studentRequireAssistanceWithYourGastronomyOptions.findIndex(
          x => x.value
        );
      } else {
        itemIndex = this.studentRequireAssistanceWithYourGastronomyOptions.findIndex(
          x => !x.value
        );
      }
      const itemStudentRequireAssistanceWithYourGastronomy = this
        .studentRequireAssistanceWithYourGastronomyOptions[itemIndex];
      itemStudentRequireAssistanceWithYourGastronomy.check = true;
      this.studentRequireAssistanceWithYourGastronomyOptions[
        itemIndex
      ] = itemStudentRequireAssistanceWithYourGastronomy;
    }
  },
  data() {
    return {
      studentRequireAssistanceToEatOptions: [
        { label: "Si", value: true, check: false },
        { label: "No", value: false, check: false }
      ],
      studentRequireAssistanceWithYourGastronomyOptions: [
        { label: "Si", value: true, check: false },
        { label: "No", value: false, check: false }
      ]
    };
  },
  methods: {
    onChangeStudentRequireAssistanceToEat(item) {
      this.$emit("input", {
        ...this.value,
        nutritionStudentRequireAssistanceToEat: item.value
      });
    },
    onChangeStudentRequireAssistanceWithYourGastronomy(item) {
      this.$emit("input", {
        ...this.value,
        nutritionStudentRequireAssistanceWithYourGastronomy: item.value
      });
    }
  }
};
</script>

<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
</style>
